<template>
   <div v-if='show_overlay' class='overlay' @click='overlayClick'></div>
</template>

<script>
export default {
    props: ['show_overlay'],
    emits: ['overlayClickListener'],
    methods:{
        overlayClick(){
            this.$emit('overlayClickListener');
        }
    },
    watch:{
        'show_overlay': function(){
        }
    }
}
</script>

<style lang="scss" scoped>
.overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 100;
    visibility: visible;
    opacity: 1;
    transition: visibility 0s, opacity 0.3s linear;
}
</style>